import React from "react";
import SearchBar from "./SearchBar";

interface SearchComponentProps {
  onSearch: (query: string) => void;
  searchTerm: string;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  onSearch,
  searchTerm,
}) => {
  return (
    <section className="flex flex-col p-6 w-full">
      <SearchBar
        onSearch={onSearch}
        placeholder="Search by name & condition"
        searchTerm={searchTerm}
      />
    </section>
  );
};

export default SearchComponent;
